import { Button, CardFooter, I18nDiscardLocaleButton, useI18nForm, useToasts } from "@dgs/core";
import { useFormikContext } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EventDetailsFormValues } from "../../types/event";
import { EventStep, EventStepKey } from "./EventStepper";

const StyledCardFooter = styled(CardFooter)`
	display: flex;
`;

const Spacer = styled.div`
	flex: 1;
`;

export const UpdateStepperFooter: FC<{ currentStepKey: EventStepKey; filteredSteps: EventStep[] }> = ({
	currentStepKey,
	filteredSteps,
}) => {
	const { t } = useTranslation();
	const { currentLanguage, fallbackLanguage } = useI18nForm();
	const { submitForm, errors } = useFormikContext<EventDetailsFormValues>();
	const { showToast } = useToasts();

	return (
		<StyledCardFooter>
			{currentStepKey === "base-data" && currentLanguage !== fallbackLanguage && <I18nDiscardLocaleButton />}
			<Spacer />
			<Button
				color="primary"
				onClick={async () => {
					const hasErrorsInOtherTabs = filteredSteps.some(
						(step) => step.key !== currentStepKey && !step.isValid(errors),
					);
					if (hasErrorsInOtherTabs) {
						showToast({
							body: t("Please fill in all required fields in every tab."),
							title: t("Update event"),
							type: "error",
						});
					}
					await submitForm();
				}}
				type="button"
			>
				{t("Save")}
			</Button>
		</StyledCardFooter>
	);
};
